// import { graphic } from 'echarts';
const COLUMN = [
  {
    name: "payrollId",
    id: "payrollId",
    label: "Payroll ID",
    widget: "text",
    fixed:'left',
    width:100
  },
  {
    name: "employeeName",
    id: "employeeName",
    label: "Employee Name",
    widget: "text"
  },

  {
    name: "role",
    id: "role",
    label: "Role",
    widget: "text"
  },
  {
    name: "date",
    id: "date",
    label: "Date & Time",
    widget: "date"
  },
  {
    name: "salary",
    id: "salary",
    label: "Total Salary",
    width:100,
    widget: "text"
  },
  {
    name: "status",
    id: "status",
    width:150,
    label: "Status",
    widget: "invoicestatus"
  },
  {
    name: "reimbursement",
    id: "reimbursement",
    label: "Reimbursement",
    widget: "text"
  },
  {
    name: "tax",
    id: "tax",
    label: "Tax",
    width:100,
    widget: "text"
  },
  {
    name: "bonus",
    id: "bonus",
    label: "Bonus",
    width:100,
    widget: "text"
  },
  {
    name: "deduction",
    id: "deduction",
    label: "Deduction",
    width:100,
    widget: "text"
  },
 
  {
    name: "netSalary",
    id: "netSalary",
    label: "Net Salary",
    width:100,
    widget: "text",
    fixed:'right'
  }
];
const ROWPAYROLL = [{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 0
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 2
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 1
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 3
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 2
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: -1
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 0
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 2
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 1
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 3
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: 2
},{
  payrollId: '#79820 - INV -12',
  employeeName: 'Qubernet Technologies',
  salary: 'USD 12854.00',
  status: -1
}];

const DONUT = {
  tooltip: {
    trigger: 'item'
  },
  legend: {
    top: '20%',
    right: '6%',
    orient: 'vertical',
    show: true,
    icon: 'circle'
  },
  color: ["#FE9082", "#D3D7E7", "#4D579F", "#3179D4"],
  series: [
    {
      type: 'pie',
      radius: ['40%', '70%'],
      avoidLabelOverlap: false,
      left: '-40%',
      showEmptyCircle: true,
      top: '8%',
      data: [
        { value: 234, name: 'Approved' },
        { value: 234, name: 'Paid' },
        { value: 234, name: 'Deleted' },
        { value: 200, name: 'Sent' },
        { value: 180, name: 'Due' },
        { value: 100, name: 'Rejected' }
      ].sort(function(a, b) {
        return a.value - b.value;
      }),
      labelLine: {
        smooth: 0.2,
        length: 7
      },
      label: {
        formatter: '{d}',
        color: "var(--palette-gray-7)"
      },
      animationType: 'scale',
      animationEasing: 'elasticOut',
      animationDelay: function() {
        return Math.random() * 200;
      }
    }
  ],
  height: "100%"
};


const grid = {
  top:'5%',
  left: '0%',
  right: '0%',
  bottom: '0%',
  containLabel: true
};
const series= [
  {
    name: 'Invoiced',
    type: 'bar',
    stack: 'total',
    emphasis: {
      disabled: true
    },
    data: [6.5,4,12,14,11,7.5]
  },
  {
    name: 'Expenses',
    type: 'bar',
    stack: 'total',
    emphasis: {
      disabled: true
    },
    data: [0, 2,0,0,0,2]
  }
];
var stackInfo = {};
for (let i = 0; i < series[0].data.length; ++i) {
  for (let j = 0; j < series.length; ++j) {
    const stackName = series[j].stack;
    if (!stackName) {
      continue;
    }
    if (!stackInfo[stackName]) {
      stackInfo[stackName] = {
        stackStart: [],
        stackEnd: []
      };
    }
    const info = stackInfo[stackName];
    const data = series[j].data[i];
    if (data && data !== '-') {
      if (info.stackStart[i] == null) {
        info.stackStart[i] = j;
      }
      info.stackEnd[i] = j;
    }
  }
}
for (let i = 0; i < series.length; ++i) {
  const data = series[i].data;
  const info = stackInfo[series[i].stack];
  for (let j = 0; j < series[i].data.length; ++j) {
    const isEnd        = info.stackEnd[j] === i;
    const topBorder    = isEnd ? 8 : 0;
    const bottomBorder = 0;
    data[j] = {
      value: data[j],
      itemStyle: {
        borderRadius: [topBorder, topBorder, bottomBorder, bottomBorder]
      }
    };
  }
}
const BILLABLE_HOURS={
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'none'
    }
  },
  color: [
    "rgba(0, 120, 103, 0.8)",
    "rgba(255, 171, 0, 0.8)"
  ],
  legend: {
    show: false
  },
  barWidth:20,
  grid,
  xAxis: {
    type: 'category',
    data: ['Jan 24', 'Feb 24', 'Mar 24', 'Apr 24', 'May 24', 'Jun 24', 'Jul 24', 'Aug 24', 'Sep 24', 'Oct 24','Nov 24','Dec 24'],
    axisLabel:{
      fontSize:9
    }
  },
  yAxis: {
    type: 'value'
  },
  series
};

const INVOICE_EXPENDITURE = {
  color: ['#e6f4ee', '#f3f2e3'],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  legend: {
    data: ['Line 1', 'Line 2', 'Line 3', 'Line 4', 'Line 5']
  },
  toolbox: {
    show:false
  },
  grid: {
    right: '2%',
    bottom: '3%',
    top:'8%',
    left:'1%',
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: false,
      data: ['Jan 24', 'Feb 24', 'Mar 24', 'Apr 24', 'May 24', 'Jun 24', 'Jul 24']
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: [
    {
      name: 'Invoiced',
      type: 'line',
      stack: 'Total',
      smooth: true,
      lineStyle: {
        width: 1,
        color:'#22c55e'
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1
        // color: graphic.LinearGradient(0, 0, 0, 1, [
        //   {
        //     offset: 0,
        //     color: 'rgba(58,77,233,0.8)'
        //   },
        //   {
        //     offset: 1,
        //     color: 'rgba(58,77,233,0.3)'
        //   }
        // ])
      },
      emphasis: {
        focus: 'series'
      },
      data: [140, 232, 101, 264, 90, 340, 250]
    },
    {
      name: 'Expenses',
      type: 'line',
      stack: 'Total',
      smooth: true,
      lineStyle: {
        width: 1,
        color:'#ffab00'
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1
        // color: graphic.LinearGradient(0, 0, 0, 1, [
        //   {
        //     offset: 0,
        //     color: 'rgba(213,72,120,0.8)'
        //   },
        //   {
        //     offset: 1,
        //     color: 'rgba(213,72,120,0.3)'
        //   }
        // ])
      },
      data: [120, 282, 111, 234, 220, 340, 310]
    }
  ]
};
const ACCOUNT_RECEIVABLE_COLUMN = [
  {
    name: "accountReceivable",
    id: "accountReceivable",
    label: "Account Receivable",
    widget: "text",
    width:100
  },
  {
    name: "total",
    id: "total",
    label: "Total",
    width:100,
    widget: "text",
    align:'right'
  }
];
const ACCOUNT_PAYABLE_COLUMN = [
  {
    name: "accountPayable",
    id: "accountPayable",
    label: "Account Payable",
    widget: "text",
    width:100
  },
  {
    name: "total",
    id: "total",
    label: "Total",
    width:100,
    widget: "text",
    align:'right'
  }
];

const INVOICE_TABLE = [
  {
    name: "customer",
    id: "customer",
    label: "Customer",
    widget: "text",
    width:100
  },
  {
    name: "create",
    id: "create",
    label: "Create",
    width:100,
    widget: "text"
  },
  {
    name: "due",
    id: "due",
    label: "Due",
    width:100,
    widget: "text"
  },
  {
    name: "salary",
    id: "salary",
    label: "salary",
    width:100,
    widget: "text"
  },
  {
    name: "sent",
    id: "sent",
    label: "Sent",
    width:100,
    widget: "text"
  },
  {
    name: "status",
    id: "status",
    label: "Status",
    width:100,
    widget: "invoiceStatus"
  }
];

export {
  COLUMN,
  ROWPAYROLL,
  DONUT,
  BILLABLE_HOURS,
  INVOICE_EXPENDITURE,
  ACCOUNT_RECEIVABLE_COLUMN,
  ACCOUNT_PAYABLE_COLUMN,
  INVOICE_TABLE
};